import constants from 'core/types'

const initialState = {
  // These represent sign in state
  onboard: null,
  walletProvider: null,

  // These are used for the collateral ratio slider
  currentAccountRatio: null,
  currentAccountBufferedRatio: null,

  // Used to track account update status in the ToastBar
  accountLastUpdateBlockNumber: null,

  // This is used to confirm trading inputs
  walletInfo: [],

  // These are used on trading pages
  overviewCurrency: '',
  portfolioOverview: null,
  collateralOverview: null,

  // These are used on the portfolio page
  maturedAssetsValue: null,
  portfolioReturns: null,
  portfolioReturnsIndex: null
}

export function walletReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_ONBOARD_SDK:
      return Object.assign({}, state, {
        onboard: action.payload.onboard
      })

    case constants.SET_WALLET:
      return Object.assign({}, initialState, {
        onboard: state.onboard,
        walletProvider: action.payload.walletProvider
      })

    case constants.SET_ACCOUNT_INFO:
      return Object.assign({}, state, {
        walletInfo: action.payload.walletInfo,
        currentAccountRatio: action.payload.currentAccountRatio,
        currentAccountBufferedRatio: action.payload.currentAccountBufferedRatio,
        maturedAssetsValue: action.payload.maturedAssetsValue,
        portfolioReturns: action.payload.portfolioReturns,
        portfolioReturnsIndex: action.payload.portfolioReturnsIndex
      })

    case constants.SET_PRESELECTED_WALLET:
      return Object.assign({}, initialState, {
        onboard: state.onboard,
        walletProvider: action.payload.walletProvider
      })

    case constants.RESET_WALLET:
      return Object.assign({}, initialState, {
        onboard: state.onboard
      })

    case constants.CALCULATE_ACCOUNT_OVERVIEW:
      return Object.assign({}, state, {
        overviewCurrency: action.currencySymbol
      })

    case constants.SET_ACCOUNT_OVERVIEW:
      return Object.assign({}, state, {
        collateralOverview: action.payload.collateralOverview,
        portfolioOverview: action.payload.portfolioOverview
      })

    case constants.SET_ACCOUNT_BLOCK_NUMBER:
      return Object.assign({}, state, {
        accountLastUpdateBlockNumber: action.payload.accountLastUpdateBlockNumber
      })

    default:
      return state
  }
}
